import styled from 'styled-components';

export const ConditionsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  span {
    font-weight: 500;
  }

  ul {
    margin: 0;
  }
`;
